import React from 'react';
import { Box } from 'theme-ui';
import Link from '@components/common/Link/Link';

type FooterLinkProps = {
  slug: string;
  title: string;
};

const FooterLink = ({ slug, title }: FooterLinkProps) => {
  return (
    <Box className="footer__item">
      <Link to={`/${slug}`}>{title}</Link>
    </Box>
  );
};

export default FooterLink;
